import { render, staticRenderFns } from "./DsTableTabs.vue?vue&type=template&id=174f8bdc&"
import script from "./DsTableTabs.vue?vue&type=script&lang=js&"
export * from "./DsTableTabs.vue?vue&type=script&lang=js&"
import style0 from "./DsTableTabs.vue?vue&type=style&index=0&id=174f8bdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports